import { render, staticRenderFns } from "./hospitalList.vue?vue&type=template&id=872c0d82&scoped=true&"
import script from "./hospitalList.vue?vue&type=script&lang=js&"
export * from "./hospitalList.vue?vue&type=script&lang=js&"
import style0 from "./hospitalList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hospitalList.vue?vue&type=style&index=1&id=872c0d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c0d82",
  null
  
)

export default component.exports